import { render, staticRenderFns } from "./BukuBesar.vue?vue&type=template&id=06a3af71&scoped=true&"
import script from "./BukuBesar.vue?vue&type=script&lang=js&"
export * from "./BukuBesar.vue?vue&type=script&lang=js&"
import style0 from "./BukuBesar.vue?vue&type=style&index=0&id=06a3af71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a3af71",
  null
  
)

export default component.exports